import React, { useEffect, useMemo } from "react";
import { Container, Row, Spinner } from "react-bootstrap";
import {
    resolveCurrentThemeName,
    themeRequiresDarkMode,
} from "../services/theme";

const AppLoading = () => {
    const [themeName, setThemeName] = React.useState(null);

    const themeIsDark = useMemo(
        () => themeRequiresDarkMode(themeName),
        [themeName],
    );

    const setThemeDataAttribute = (themeName) => {
        setThemeName(themeName);
        document.documentElement.setAttribute("data-bs-theme", themeName);
    };

    useEffect(() => {
        setThemeDataAttribute(resolveCurrentThemeName() || "light");
    }, []);

    return (
        <>
            <div id="background" />

            <div
                id="app-loading"
                className="h-100 w-100"
                style={{
                    backgroundColor: themeIsDark
                        ? "rgb(55, 55, 55)"
                        : "#EEEEEEFF",
                }}
            >
                <Container className="h-100 justify-content-center">
                    <Row className="h-100 justify-content-center">
                        <div className="col-auto align-self-center">
                            <div
                                style={{ width: "300px", position: "relative" }}
                            >
                                <div>
                                    <p className="text-center">
                                        <Spinner
                                            animation="border"
                                            role="status"
                                            variant={
                                                themeIsDark
                                                    ? "brand-primary"
                                                    : "secondary"
                                            }
                                            as="span"
                                            size="sm"
                                            className="me-2"
                                        >
                                            <span className="visually-hidden">
                                                Loading...
                                            </span>
                                        </Spinner>
                                        Loading 7fivefive Lens...
                                    </p>
                                </div>
                                <noscript>
                                    <div className="message-div">
                                        <div className="alert alert-danger">
                                            <strong>Error: </strong>
                                            Javascript is required for this
                                            product to work. Please enable and
                                            login.
                                        </div>
                                    </div>
                                </noscript>
                            </div>
                        </div>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default AppLoading;
